import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import RenderToast from "components/Core/RenderToast";
import { Logo } from "constant/imagePath";
import { validateEmail } from "constant/regex";
import ConfirmPasswordModal from "modals/ConfirmPasswordModal";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Patch, Post } from "../../axios/AxiosFunctions";
import { apiHeader, BaseURL } from "../../config/apiUrl";
import ForgotPasswordModal from "../../modals/ForgotPasswordModal";
import OtpModal from "../../modals/OtpModal/OtpModal";
import { saveLoginUserData } from "../../store/auth/authSlice";
import classes from "./Login.module.css";

const Login = () => {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [forgotPassEmail, setForgotPassEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const headers = apiHeader();

  const handleLogin = async (e) => {
    e.preventDefault();
    let params = {
      email,
      password,
    };
    for (let key in params) {
      if (!params[key]) {
        return RenderToast({
          type: "error",
          message: `Please fill the ${key} field!`,
        });
      }
    }
    if (!validateEmail(email)) {
      return RenderToast({
        type: "error",
        message: "Please enter correct email!",
      });
    }
    if (params["password"]?.length < 8) {
      return RenderToast({
        type: "error",
        message: "Password must contain min 8 characters",
      });
    }
    setLoading("loginLoader");
    const response = await Post(
      BaseURL("auth/admin-login"),
      params,
      apiHeader()
    );
    if (response !== undefined) {
      RenderToast({ type: "success", message: "Login Successful" });
      dispatch(saveLoginUserData(response?.data));
      navigate("/");
    }
    setLoading(false);
  };

  const handleForgotPassword = async (email) => {
    setLoading("forgotLoading");
    const response = await Post(
      BaseURL(`auth/forgot-password`),
      { email },
      headers
    );
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message:
          "OTP code has been sent successfully. Please check your email!",
      });
      setForgotPassEmail(email);
      setModalOpen("otpModal");
    }
    setLoading(false);
  };

  const handleResetPassword = async (params) => {
    setLoading("otpLoader");
    const response = await Patch(BaseURL(`auth/verify-otp`), params, headers);
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "Otp code is valid. Please change your password!",
      });
      setModalOpen("confirmpassmodal");
      setCode(params?.code);
    }
    setLoading(false);
  };

  const handleConfirmPassword = async (params) => {
    setLoading("confirmPassLoader");
    const response = await Patch(
      BaseURL(`auth/reset-password`),
      params,
      headers
    );
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "Password has been changed successfully!",
      });
      setModalOpen(false);
    }
    setLoading(false);
  };

  const handleResendOtp = async (email) => {
    setLoading("resendOtpLoader");
    const response = await Patch(
      BaseURL(`auth/resend-otp`),
      { email },
      headers
    );
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message:
          "OTP code has been sent successfully. Please check your email!",
      });
    }
    setLoading(false);
  };
  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.formContainer}>
          <img src={Logo} alt="logo" className={classes.logoImg} />
          <h6 className={classes.loginHeading}>LOGIN</h6>
          <form onSubmit={handleLogin} className={classes.loginForm}>
            <Input
              placeholder="Email"
              type="email"
              value={email}
              setter={setEmail}
              label={"Email"}
            />
            <Input
              placeholder="Password"
              value={password}
              setter={setPassword}
              type="password"
              label={"Password"}
            />
            <p className={classes.forgetPass}>
              <span
                onClick={() => {
                  setModalOpen("forgotPasswordModal");
                }}
              >
                Forgot Password?
              </span>
            </p>
            <Button
              className={classes.loginBtn}
              label={loading === "loginLoader" ? "Loading..." : "LOGIN"}
              disabled={loading}
            />
          </form>
        </div>
      </div>

      {modalOpen === "forgotPasswordModal" && (
        <ForgotPasswordModal
          setShow={setModalOpen}
          show={modalOpen}
          isLoading={loading === "forgotLoading"}
          onclick={handleForgotPassword}
        />
      )}

      {modalOpen === "otpModal" && (
        <OtpModal
          setShow={setModalOpen}
          show={modalOpen}
          email={forgotPassEmail}
          handleOtpFunc={handleResetPassword}
          isOtpSend={loading === "otpLoader"}
          resendOtp={handleResendOtp}
          resendOtpLoader={loading === "resendOtpLoader"}
        />
      )}
      {modalOpen === "confirmpassmodal" && (
        <ConfirmPasswordModal
          show={modalOpen}
          setShow={setModalOpen}
          onclick={handleConfirmPassword}
          email={forgotPassEmail}
          code={code}
          loader={loading === "confirmPassLoader"}
        />
      )}
    </>
  );
};

export default Login;
